import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { PaginatedApiResponse } from '@wdx/clmi/api-services/models';
import { NudgeType } from '@wdx/clmi/clmi-swagger-gen';
import { Observable } from 'rxjs';
import { ConfigService } from '../../services/config.service';

@Injectable()
export class NudgeTypesService {
    constructor(
        private http: HttpClient,
        private config: ConfigService,
    ) {}

    getAll(): Observable<PaginatedApiResponse<NudgeType>> {
        return this.http.get<PaginatedApiResponse<NudgeType>>(
            `${this.config.getConfiguration().API_BASE}/nudgetype`,
            {},
        );
    }
}
